import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Component, Fragment } from "react";
import "react-step-progress-bar/styles.css";
import DayCardCheckbox from "../components/DayCardCheckbox";
import DialogIframe from "../components/DialogIframe";
import LinkToGoogleFormIframe from "../components/LinkToGoogleFormIframe";



const styles = {
  root: {
    margin: "1.5em auto 1.5em auto",
  },

  lightText: {
    fontWeight: "100",
  },
};

class DayCard extends Component {
  //TODO: hack this by using a stateful component for now instead of using redux...
  state = { expanded: false }
  render() {
    const { classes } = this.props;

    const dayCard = this.props.dayCard
    const dayId = dayCard.dayId

    const handleExpandClick = () => {
      this.setState({ expanded: !this.state.expanded });
    };

    // create resources list links
    function createResourceList(dayCard) {
      const resources = dayCard.resources;
      const keys = Object.keys(resources);
      keys.sort();
      const resourceListItems = keys.map((key) => {
        const title = key.replace(/^[0-9]+/, '').trim();
        return (
          <ListItem key={key} >
            <DialogIframe dayId={dayId} title={title} href={resources[key]}>
              {title}
            </DialogIframe>
          </ListItem>
        );
      });
      return resourceListItems
    }

    // hack day of the week (disabled for autopilot)
    // const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

    return (
      <Card className={classes.root} variant="outlined">
        <CardContent>
          {/* TODO: Make `X` in Day X be part of api return instead of using index */}
          <Typography variant="h4" gutterBottom>
            {/* hack day of the week */}
            Topic {this.props.day}
          </Typography>
          <Typography variant="body1">
            <b>{dayCard.dayTitle}</b>
          </Typography>
          <Typography>
            <span
              onClick={this.contentClickHandler}
              dangerouslySetInnerHTML={{ __html: dayCard.description }}
            />
          </Typography>
           {/* TODO: check if syllabus is actuall populated */}
          
          {dayCard.dayId ? 
          <Fragment>
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={this.state.expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
            <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
              <Typography variant="h5">Resources for the day</Typography>
              <List>
                {createResourceList(dayCard)}
              </List>

              <Typography variant="h5">Things to do</Typography>
              {/* pass the day id to know which day to render from state */}
              {/* TODO: check if syllabus is actuall populated */}
              <DayCardCheckbox day={this.props.day} dayId={this.props.dayId} />
              <LinkToGoogleFormIframe typography="body1" title="Quiz" href={dayCard.quizLink} dayId={dayId}>
               End-of-day Activity
              </LinkToGoogleFormIframe>
            </Collapse>
          </Fragment>
           : <Typography className={classes.lightText} variant="body1">Coming Soon</Typography>
           }
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(DayCard);
